import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth/auth.service';
import { VehiclesComponent } from '../../../components/vehicles/vehicles.component';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';

@Component({
  selector: 'app-vehicles-list',
  standalone: true,
  imports: [CommonModule, FormsModule, ImageSectionHeadComponent, VehiclesComponent],
  templateUrl: './vehicles-list.component.html',
  styleUrl: './vehicles-list.component.scss'
})
export class VehiclesListComponent {
  title = $localize`:@@Router.Vehicles.MyVehicles:Mis autorizaciones`;
  description = "";
  image = "assets/images/teclado.jpg";

  currentAppliant: string | null = null;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    const applicantCreated = sessionStorage.getItem('currentAppliant');
    if (!applicantCreated) {
      this.router.navigate(['/register']);
    } else {
      this.currentAppliant = this.authService.getCurrentUser().documentNumber;
    }
  }

  goToNewException(plate: string) {
    this.router.navigate(['exceptions', plate, 'new']);
  }
  
  goToNewVehicle() {
    this.router.navigate(['/vehicles/new']);
  }
}
